import React from 'react';
import Image from '../images';
import './ErrorMessage.scss';

const ErrorMessage = ({ errors, onClose }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <div className="ErrorMessage">
      <div>
        <Image type="Close" onClick={onClose} color="#5a4e4e" />
        <ul>
          {errors.map((error, index) => (
            <li key={index}>{error}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ErrorMessage;
